import React from "react";
import Marquee from "react-fast-marquee";
import { HiStar } from "react-icons/hi2";
import { getDownloadLink } from "../../utils/app-download-link";
import AppLogo from "../../assets/images/mahi-download-logo-512.png";
import BottomSheet from "../common/bottom-sheet"; // 새로운 컴포넌트 경로
import ResponsiveCDNImage from "../common/image/responsive-cdn-image";

interface AppDownloadBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  showOverlay?: boolean;
}

const reviews = [
  {
    src: "https://cdn-mahi.com/review1.png",
    alt: "review1",
    price: 8900,
  },
  {
    src: "https://cdn-mahi.com/review2.png",
    alt: "review2",
    price: 4000,
  },
  {
    src: "https://cdn-mahi.com/review3.png",
    alt: "review3",
    price: 3700,
  },
  {
    src: "https://cdn-mahi.com/review4.png",
    alt: "review4",
    price: 6900,
  },
  {
    src: "https://cdn-mahi.com/review5.png",
    alt: "review5",
    price: 8900,
  },
  {
    src: "https://cdn-mahi.com/review6.png",
    alt: "review6",
    price: 6200,
  },
];

const AppDownloadBottomSheet: React.FC<AppDownloadBottomSheetProps> = ({
  isOpen,
  onClose,
  showOverlay = true,
}) => {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} showOverlay={showOverlay}>
      <div className="pt-4 flex flex-col items-center gap-4">
        {/* 로고와 평점 */}
        <div className="flex items-center gap-4 mb-2">
          <img src={AppLogo} alt="App Logo" className="w-20 h-20" />
          <div className="flex flex-col items-center gap-1">
            <div className="flex items-center gap-1">
              <HiStar className="text-yellow-400 text-lg" />
              <span className="text-lg font-bold text-gray-800">4.8</span>
            </div>
          </div>
        </div>

        {/* 제목 */}
        <p className="text-lg font-bold text-gray-800 text-center gap-2">
          <span>
            앱에서 <span className="text-[#1692fc]">4,000개</span> 의 리뷰를
            <br /> 확인하고 함께 지구를 지켜요! 👋
          </span>

          <span className="block text-[#1562fc] text-xl font-bold mt-4">
            지금 다운로드 시,
            <br />
            🎁{" "}
            <span className="pb-1 bg-[#1562fc] text-white text-base px-3 py-1 rounded-full font-semibold align-middle mx-1">
              스탬프 2개
            </span>{" "}
            웰컴 스탬프도 드려요! 🎁
          </span>
          <span className="block text-sm font-medium text-gray-600 mt-3 leading-snug">
            스탬프 10개 모으면 1,000원 할인 쿠폰으로 교환할 수 있습니다.
          </span>
        </p>

        {/* 리뷰 ticker */}
        <div className="w-full mt-2 z-[100]">
          <Marquee direction="right" speed={30} gradient={false}>
            {reviews.map((review, idx) => (
              <div
                key={`review-${idx}`}
                className="h-28 w-28 rounded-lg mx-2 relative"
              >
                <ResponsiveCDNImage
                  src={review.src}
                  alt={review.alt}
                  className="w-full h-full object-cover rounded-lg"
                />
                {/* 가격 칩 */}
                <div className="absolute bottom-1 right-1">
                  <div className="bg-black/70 text-white text-xs px-2 py-1 rounded-md font-medium">
                    {review.price.toLocaleString()}원
                  </div>
                </div>
              </div>
            ))}
          </Marquee>
        </div>

        {/* 버튼 영역 */}
        <div className="flex gap-4 mt-4 w-full max-w-xs">
          {/* 닫기 버튼 */}
          <button
            onClick={onClose}
            className="flex-[3] py-3 bg-gray-300 text-gray-700 font-bold rounded-lg shadow-md hover:bg-gray-400 transition-all duration-200"
          >
            닫기
          </button>

          {/* 다운로드 버튼 */}
          <a
            href={getDownloadLink()}
            className="flex-[7] py-3 bg-[#1692fc] text-white font-bold rounded-lg shadow-md flex items-center justify-center hover:bg-[#1177cc] transition-all duration-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            다운로드하고 알림받기
          </a>
        </div>
      </div>
    </BottomSheet>
  );
};

export default AppDownloadBottomSheet;
